import { render, staticRenderFns } from "./salesTablehx.vue?vue&type=template&id=046f4242"
import script from "./salesTablehx.vue?vue&type=script&lang=js"
export * from "./salesTablehx.vue?vue&type=script&lang=js"
import style0 from "./salesTablehx.vue?vue&type=style&index=0&id=046f4242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports